import { Box } from "@chakra-ui/react";
import React from "react";

import type { AddressSignedAuthorization } from "types/api/address";

import { Skeleton } from "toolkit/chakra/skeleton";
import { TableRow, TableCell } from "toolkit/chakra/table";
import AddressEntity from "ui/shared/entities/address/AddressEntity";

import {
  formatAuthorizationStatus,
  formatValidityLabel,
  getChainNameById,
} from "./utils";
interface Props extends AddressSignedAuthorization {
  isLoading?: boolean;
}

const AddressAuthorizationsTableItem = ({
  address_hash: addressHash,
  authority,
  chain_id: chainId,
  nonce,
  status,
  validity,
  isLoading,
}: Props) => {
  const statusLabel = formatAuthorizationStatus(status);
  const statusColor = status === "ok" ? "green.500" : "text.error";

  return (
    <TableRow alignItems="center">
      <TableCell>
        <AddressEntity
          address={{ hash: addressHash }}
          isLoading={isLoading}
          noIcon
        />
      </TableCell>
      <TableCell isNumeric verticalAlign="middle">
        <AddressEntity
          address={{ hash: authority }}
          isLoading={isLoading}
          noIcon
        />
      </TableCell>
      <TableCell verticalAlign="middle">
        <Skeleton loading={isLoading} display="inline-block">
          {getChainNameById(chainId)}
        </Skeleton>
      </TableCell>
      <TableCell isNumeric verticalAlign="middle">
        <Skeleton loading={isLoading} display="inline-block">
          {nonce}
        </Skeleton>
      </TableCell>
      <TableCell isNumeric verticalAlign="end">
        <Skeleton loading={isLoading} display="inline-block">
          <Box as="span" color={statusColor}>
            {statusLabel}
          </Box>
        </Skeleton>
      </TableCell>
    </TableRow>
  );
};

export default React.memo(AddressAuthorizationsTableItem);
